export default "__VITE_ASSET__PlA$GJHD__"